/**
 * Debug deep links (S1-19): `?t=1979-07-09T22:00Z&mode=overview&focus=jupiter&follow=voyager-2&lang=de&debug=1&fps=1`,
 * plus `quality=high|medium|low` (S2-07) and `intro=0|1` (S2-12).
 * Read once on start; `urlSync.ts` writes the view back into the address bar from the first change on.
 */
import { type Quality, isQuality } from '../core/quality';
import { parseUtc } from '../core/time';
import type { ScaleMode } from '../core/scaleProfiles';
import { type Lang, isLang } from '../i18n';

export interface DeepLink {
  t?: number;
  mode?: ScaleMode;
  focus?: string;
  follow?: string;
  /** `mission=cassini-huygens` opens the mission's detail panel (S3-16, D16). */
  mission?: string;
  lang?: Lang;
  speed?: string;
  play?: boolean;
  quality?: Quality;
  /** `intro=1` forces the intro, `intro=0` skips it (S2-12). */
  intro?: boolean;
  debug: boolean;
  fps: boolean;
}

export function parseDeepLink(search: string): DeepLink {
  const q = new URLSearchParams(search);
  const link: DeepLink = { debug: q.get('debug') === '1', fps: q.get('fps') === '1' || q.get('debug') === '1' };
  const t = q.get('t');
  if (t) {
    try {
      link.t = parseUtc(t);
    } catch {
      console.warn(`Ignoring invalid deep-link time: ${t}`);
    }
  }
  const mode = q.get('mode');
  if (mode === 'overview' || mode === 'realistic') link.mode = mode;
  const focus = q.get('focus');
  if (focus) link.focus = focus;
  const follow = q.get('follow');
  if (follow) link.follow = follow;
  const mission = q.get('mission');
  if (mission) link.mission = mission;
  const lang = q.get('lang');
  if (isLang(lang)) link.lang = lang;
  const speed = q.get('speed');
  if (speed) link.speed = speed;
  if (q.get('play') === '1') link.play = true;
  const quality = q.get('quality');
  if (isQuality(quality)) link.quality = quality;
  const intro = q.get('intro');
  if (intro === '1' || intro === '0') link.intro = intro === '1';
  return link;
}
